import React from 'react'
import Announcement from 'components/Announcements'
import { FF_FAVUR_REDESIGN } from 'constants/featureFlags'
import useFeatureFlag from 'hooks/useFeatureFlag'
import RedesignThemeWrapper from 'redesign/components/atoms/RedesignThemeWrapper'
import AnnouncementDialog from 'redesign/components/organisms/announcement-dialog'
import type { Block } from 'shared/graphql/graphql'
import AnnouncementsContext from './context'
import { useAnnouncementsService } from './useAnnouncementsService'

interface IAnnouncementsServiceProps {
  children?: React.ReactNode
}

const AnnouncementsService: React.FC<IAnnouncementsServiceProps> = ({ children }) => {
  const { routeAnnouncement, showAnnouncement, setShowAnnouncement, openAnnouncement, refetch } =
    useAnnouncementsService()
  const redesignFF = useFeatureFlag(FF_FAVUR_REDESIGN)

  return (
    <AnnouncementsContext.Provider value={{ openAnnouncement }}>
      {redesignFF ? (
        <RedesignThemeWrapper>
          <AnnouncementDialog
            onClose={() => {
              setShowAnnouncement(false)
              refetch()
            }}
            open={showAnnouncement}
            blocks={(routeAnnouncement?.announcement?.blocks as Block[]) ?? []}
          />
        </RedesignThemeWrapper>
      ) : (
        <Announcement
          blocks={(routeAnnouncement?.announcement?.blocks as Block[]) ?? []}
          open={showAnnouncement}
          onClose={() => {
            setShowAnnouncement(false)
            refetch()
          }}
        />
      )}
      {children}
    </AnnouncementsContext.Provider>
  )
}

export default AnnouncementsService
